import React from 'react';

const abm = () => {
    return (
<>
  <section
    className="seo-ban abm-ban text-center"
    style={{ backgroundImage: "url(assets/img/abm-bg.png)" }}
  >
    <i className="glow-2" />
    <div className="container-lg inner-container position-relative">
      <h1 className="seo-ts-head">
        B2B Specialized Account-Based Marketing Services
      </h1>
      <div className="row justify-content-center">
        <div className="col-xl-9">
          <h2 className="seo-ts-head-2">
            From spray-and-pray to targeted precision.
          </h2>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-lg-10 px-lg-5">
          <p className="mb-lg-4">
            Let’s face it: the ‘spray-and-pray’ method is as outdated as dial-up
            internet. In today’s digitally-connected business arena, it’s all
            about sharp, smart strategies.&nbsp; That’s exactly what
            Account-Based Marketing (ABM) delivers.&nbsp;
          </p>
          <p>
            Here at Purplepatch, we’re experts in upgrading your marketing game
            by using laser-focused tactics to match your message with the right
            eyes. We zero in on key accounts to ensure that your marketing
            efforts not only hit the mark but also resonate and deliver real,
            measurable results.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="top-places"
    style={{ backgroundImage: "url(assets/img/top-places.png)" }}
  >
    <i
      className="top-places-shape"
      style={{ backgroundImage: "url(assets/img/top-places-shape-abm.png)" }}
    />
    <div className="container-lg inner-container position-relative text-white">
      <div className="row">
        <div className="col-xl-5 col-md-6 pe-lg-4">
          <h2>
            <span className="c-F0B2FF">Account-Based Marketing</span> Services
            for B2B Enterprises
          </h2>
          <p>
            Account-Based Marketing (ABM) focuses on key accounts with tailored
            strategies, allowing businesses to align marketing efforts directly
            with sales targets, driving significant and measurable growth.&nbsp;
          </p>
          <p>
            Our ABM services are designed with precision targeting to reach the
            right decision-makers, ensuring that every marketing effort counts
            towards your business's success.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section className="bg-010101 ui-pt-res-100 ui-pb-res-60">
    <div className="container-lg inner-container position-relative text-white">
      <h3 className="ts-parallel text-white">
        Our Account-Based Marketing (ABM) Approach
      </h3>
      <h4 className="fs-32 ui-mb-res-30 text-white">
        <i>The 4-Step Process to Make ABM Work</i>
      </h4>
      <div className="row">
        <div className="col-xl-10">
          <p className="wee-off">
            Embarking on ABM is a strategic journey, and our 4-Step Process is
            designed to convert high-priority prospects into loyal customers.
          </p>
        </div>
      </div>
      <div className="row rw-divide-1">
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 identify-icon"></div>
            <h5>Identify</h5>
            <p>
              We begin by meticulously identifying high-value accounts in
              specific companies that align closely with your business offerings
              and growth objectives.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 expand-icon"></div>
            <h5>Expand</h5>
            <p>
              Next, we expand your reach within these accounts, uncovering key
              stakeholders and influencers to create broader engagement
              opportunities.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 engage-icon"></div>
            <h5>Engage</h5>
            <p>
              We then engage these accounts across digital touch points with
              personalized content to ensure that each interaction is relevant
              and impactful.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 convert-icon"></div>
            <h5>Convert</h5>
            <p>
              Finally, we focus on converting these interactions into meaningful
              business opportunities, driving sales and fostering lasting
              relationships.
            </p>
          </div>
        </div>
      </div>
      <h3 className="ts-parallel ui-mb-res-30 ui-pt-res-30 text-white">
        Our Account-Based Marketing (ABM) Services
      </h3>
      <div className="row">
        <div className="col-xl-11">
          <p className="wee-off">
            Our ABM services are crafted to meet the unique needs of your B2B
            business, ensuring a personalized approach to account targeting.
          </p>
        </div>
      </div>
      <div className="row rw-divide-1">
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 target-account-icon"></div>
            <h5>Target Account Identification:</h5>
            <p>
              At the heart of effective ABM is identifying the right accounts.
              We employ advanced analytics and market research to pinpoint your
              ideal customers, creating a tailored list that aligns with your
              business goals. This process ensures a concentrated effort on
              accounts with the highest potential for conversion and growth.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 personalized-icon"></div>
            <h5>Personalized Content Creation:</h5>
            <p>
              Once target accounts are identified, we specialize in crafting
              personalized content that speaks directly to their specific needs
              and interests. Our team develops bespoke content strategies, from
              blog posts to whitepapers, designed to engage and nurture these
              key accounts effectively.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 ABM-icon"></div>
            <h5>ABM Campaign Execution:</h5>
            <p>
              Implementing ABM campaigns with precision is our forte. From
              targeted email marketing to customized social media campaigns, we
              ensure that each initiative is executed seamlessly, targeting the
              identified accounts with the right message at the right time, to
              maximize engagement and conversion.
            </p>
          </div>
        </div>
        <div className="col-xl-3 col-lg-4 col-md-6">
          <div className="bx-1">
            <div className="bx-icon icon-list-2 account-based-icon"></div>
            <h5>Account-Based Analytics:</h5>
            <p>
              To continuously refine and improve our ABM strategies, we
              implement comprehensive account-based analytics. This approach
              allows us to track engagement, measure campaign effectiveness, and
              provide actionable insights, ensuring your marketing efforts are
              always evolving and aligned with the market dynamics.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="inside-chooser">
    <div className="container-lg inner-container position-relative">
      <div className="row">
        <div className="col-lg-6 pe-xl-5">
          <h3 className="tp-ms-head">
            Benefits of{" "}
            <span className="c-primary1">Account-Based Marketing (ABM)</span>{" "}
            Services{" "}
          </h3>
          <p className="tp-ms-desc">
            Adopting ABM offers multiple advantages, pivotal to scaling your
            business in the B2B space.
          </p>
        </div>
        <div className="col-lg-6 px-xl-5">
          <ul className="list-style-1 list-style-1-cnt">
            <li>
              <span className="hhtop">Increased Conversion Rates:</span>
              <p>
                ABM's targeted approach leads to higher engagement levels,
                resulting in increased conversion rates and more efficient sales
                cycles.
              </p>
            </li>
            <li>
              <span className="hhtop">Enhanced Customer Retention:</span>
              <p>
                By providing tailored experiences and solutions, ABM fosters
                stronger relationships, enhancing customer loyalty and
                retention.
              </p>
            </li>
            <li>
              <span className="hhtop">Improved ROI:</span>
              <p>
                ABM's focus on high-value accounts ensures that your marketing
                efforts yield a higher return on investment, maximizing your
                marketing spend.
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section className="table-section">
    <div className="container-lg inner-container position-relative">
      <h3 className="text-black fs-40 fw-6 ui-mb-res-30">
        Our Account-Based Marketing (ABM) Process
      </h3>
      <div className="row">
        <div className="col-xl-11">
          <h5 className="text-black ui-mb-res-40">
            At Purplepatch Services, we are committed to crafting a custom ABM
            service package that aligns perfectly with your unique business
            requirements and goals.
          </h5>
        </div>
      </div>
      <div className="table-responsive text-center">
        <table className="table table-1">
          <thead>
            <tr>
              <td>Content Development</td>
              <td>Marketing Automation</td>
              <td>Paid Advertising</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Blog Posts</td>
              <td>Email nurture tracks</td>
              <td>Google Advertising</td>
            </tr>
            <tr>
              <td>Ebooks</td>
              <td>Sales nurture tracks</td>
              <td>LinkedIn Advertising</td>
            </tr>
            <tr>
              <td>White Papers</td>
              <td>Email content creation</td>
              <td>Twitter Advertising</td>
            </tr>
            <tr>
              <td>Videos</td>
              <td>SEO and SMO</td>
              <td>Facebook Advertising</td>
            </tr>
            <tr>
              <td>Podcasts</td>
              <td>Automated target account identification</td>
              <td />
            </tr>
            <tr>
              <td>Infographics</td>
              <td>Automated persona identification</td>
              <td />
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
  <section className="seo-accordion accordion-style">
    <div className="container-lg inner-container position-relative text-white">
      <h3 className="ts-parallel text-black ui-mb-res-60">
        FAQs about Account-Based Marketing (ABM) Services
      </h3>
      <div className="accordion" id="ac1">
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              What is Account-based marketing?
            </button>
          </h5>
          <div
            id="collapseOne"
            className="accordion-collapse collapse show"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                Account-based marketing is a strategic approach that
                concentrates marketing resources on a set of target accounts
                within a market. It uses personalized campaigns designed to
                resonate with each account, ensuring that marketing efforts are
                more relevant and effective.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Benefits of Account-based marketing?
            </button>
          </h5>
          <div
            id="collapseTwo"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                2B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              What is the ideal company size for ABM?
            </button>
          </h5>
          <div
            id="collapseThree"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                B SEO services involve optimizing a business's online presence
                to improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefour"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How does marketing automation work in ABM?
            </button>
          </h5>
          <div
            id="collapsefour"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsefive"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How long does it take to see results from ABM campaigns?
            </button>
          </h5>
          <div
            id="collapsefive"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapsesix"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              How does ABM accelerate sales pipeline growth?
            </button>
          </h5>
          <div
            id="collapsesix"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
        <div className="accordion-item">
          <h5 className="accordion-header">
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseseven"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              Can ABM be integrated with other marketing strategies?
            </button>
          </h5>
          <div
            id="collapseseven"
            className="accordion-collapse collapse"
            data-bs-parent="#ac1"
          >
            <div className="accordion-body">
              <p>
                SEO services involve optimizing a business's online presence to
                improve its visibility in search engine results, specifically
                targeting other businesses as customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section
    className="footer-above-services text-white"
    style={{ backgroundImage: "url(assets/img/footer-above-services.png)" }}
  >
    <div className="container-lg inner-container">
      <h3 className="tp-set">
        Get Started with Our{" "}
        <span className="c-FDB3D4">Account-Based Marketing (ABM) Services</span>
      </h3>
      <div className="row">
        <div className="col-xl-7 pe-lg-4">
          <p>
            Ready to transform your B2B marketing approach? Schedule a
            consultation with us to explore how our ABM services can forge
            meaningful connections between your brand and your most valuable
            prospects.
          </p>
          <p>
            When you team up with <b>Purplepatch</b> for your ABM journey,
            you're not just getting a service; you're choosing a partner who
            excels in the art of B2B marketing. We're not just about ticking
            boxes; we believe in creating personalized engagement that exceeds
            your marketing goals. Let's make each engagement count, together.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section
    className="get-form-touch"
    style={{ backgroundImage: "url(assets/img/get-form-touch.png)" }}
  >
    <div className="container-lg inner-container">
      <div className="row">
        <div className="col-md-6 text-white">
          <h5 className="ss-1">Contact</h5>
          <h4 className="ss-2">
            Ready to start your growth with Our B2B Digital Marketing Service?
          </h4>
          <div className="home-feat-article">
            <div className="dflex-1 text-black">
              <div className="dflex-1-cnt">
                <h6>Featured Article</h6>
                <h5>What is good conversion rate?</h5>
              </div>
              <div className="dflex-1-icon">
                <img src="assets/img/peop-1.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6 text-white">
          <h6 className="ss-3">
            Your success story begins here. Connect with us today!
          </h6>
          <p>
            Are you ready to start elevating your brand and getting results?
            Then stop reading and start typing! Fill out the form and let’s
            begin…
          </p>
        </div>
      </div>
    </div>
  </section>
</>
 );
};

export default abm;
